/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RoleBatchResponse {
    getFixupPrototypeFunction() { return RoleBatchResponse.fixupPrototype; }

    static newInstance(model: Partial<RoleBatchResponse>): RoleBatchResponse {
        let obj = Object.assign(new RoleBatchResponse(), model);
        RoleBatchResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RoleBatchResponse>): RoleBatchResponse {
        if (!model) return null;
        return RoleBatchResponse.newInstance(<RoleBatchResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RoleBatchResponse) {
        if (!obj) return;

        models.RoleBatchResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RoleBatchResponse): boolean {
        Object.setPrototypeOf(obj, RoleBatchResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.results) {
            for (let key in this.results) {
                let val = this.results[key];
                if (val) {
                    models.RoleView.fixupPrototype(val);
                }
            }
        }
    }

    /**
     * Map from identifier to response model
     */
    results: { [key: string]: models.RoleView; };

}
